import * as React from "react";
import { TTranslate } from "../../../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import { IReportingPeriodPermission } from "../../../../../model/reporting/ReportingPeriodPermission";
import PeriodPermissionForm from "./PeriodPermissionForm";
import { IUserCode } from "../../../../../model/user/UserCode";

export interface State {}

export interface UpdateReportingPeriodPermissionFormProps
  extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  rowData: IReportingPeriodPermission;
  codebooks: IUserCode[];
}

class UpdateReportingPeriodPermissionForm extends React.Component<
  UpdateReportingPeriodPermissionFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newReportingPeriodPermissionData = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newReportingPeriodPermissionData = values;
        }
      });
      return newReportingPeriodPermissionData;
    });
  }

  render() {
    const { translate, rowData, codebooks } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <PeriodPermissionForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        codebooks={codebooks}
        rowData={rowData}
        disabled={true}
      />
    );
  }
}

export default UpdateReportingPeriodPermissionForm;
